import Button from "react-bootstrap/Button";
import Offcanvas from "react-bootstrap/Offcanvas";
import useMetaMask from "hooks/metsmask";
import { useNavigate } from "react-router-dom";
import toastr from "toastr";
import { getBalance } from "utils/metamask";
import { useEffect, useState } from "react";

const Addfund = ({ show, handleClose, handleShow }) => {
  let walletAddress = localStorage.getItem("walletAddress");
  const navigate = useNavigate();
  const hooks = useMetaMask();
  const [get, setget] = useState();

  const Redirect = (e) => {
    e.preventDefault();
    if (walletAddress) {
      handleShow();
    } else {
      toastr("Please connect your account!", {
        icon: "👏",
      });
      navigate("/metamask-sign");
    }
  };


  useEffect(() => {
    (async () => {
      try {
        const balanceData = await getBalance(walletAddress);
        setget(balanceData);
      } catch (error) {
        console.log(error);
      }
    })();
  }, [walletAddress]);

  return (
    <>
      <Offcanvas show={show} onHide={handleClose} placement={"end"}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Add funds</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="text-center">
          Total balance
          <br />
          {walletAddress ? (
            <>
              {Number(get)?.toFixed(8) || 0}

              {hooks?.chainId == "80001"
                ? "MATIC"
                : hooks?.chainId == "97"
                ? "BNB"
                : "ETH"}
            </>
          ) : (
            "N/A"
          )}
          <div>
            <Button
              className="btn-commonblack"
              onClick={(e) => {
                Redirect(e);
                handleClose();
              }}
            >
              {walletAddress ? "Add Funds" : "Connect Account"}
            </Button>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};
export default Addfund;
